export const getStartedFormInputs = [
  {
    name: 'first_name',
    label: 'First Name',
    required: true,
  },
  {
    name: 'last_name',
    label: 'Last Name',
    type: 'text',
    required: true,
  },
  {
    name: 'username',
    label: 'Email',
    type: 'email',
    required: true,
  },
  {
    name: 'phone',
    label: 'Phone Number',
    type: 'tel',
    mask: '999-999-9999',
    required: true,
    tag: 'InputMask',
  },
];
